import bnyCaseStudyPdf from 'url:../assets/files/bny-swirepay-case-study-real-estate-disbursement-baas-global.pdf';
import bnyCaseStudyBannerImage from 'url:../assets/img/case-study-swirepay-bny.png'

const trackCaseStudyDownloadUrl = process.env.TRACK_CASE_STUDY_DOWNLOAD_URL;

// ── Data ─────────────────────────────────────────────────────────────────────

const caseStudies = [
  {
    id: 'cs-1',
    category: 'Real Estate',
    categorySlug: 'real-estate',
    title: 'How BNY and Swirepay accelerate settlement and improve operational efficiency',
    description:
      "Swirepay worked with BNY to help real estate organizations digitize their disbursements and introduce real-time speed, while also streamlining reconciliation, gaining not only real-time payment confirmation and remittance visibility but an improvement to overall productivity.",
    keyResult: 'Reduced turnaround times by 3 days',
    company: 'Bank of New York',
    docYear: '',
    outcome: '90% reduction in vendor payout times',
    // img: 'https://www.swirepay.com/get-paid-faster.ac354ca4.png',
    img: bnyCaseStudyBannerImage,
    url: '#',
    pdfUrl: bnyCaseStudyPdf,
  },
];

// ── Accessors ─────────────────────────────────────────────────────────────────

export function getCategories() {
  const seen = new Set();
  return caseStudies
    .map(function (s) { return { label: s.category, slug: s.categorySlug }; })
    .filter(function (c) {
      if (seen.has(c.slug)) return false;
      seen.add(c.slug);
      return true;
    });
}

export function getStudies(categorySlug) {
  if (!categorySlug || categorySlug === 'all') return caseStudies;
  return caseStudies.filter(function (s) { return s.categorySlug === categorySlug; });
}

// ── Renderers ─────────────────────────────────────────────────────────────────

function buildCardHtml(study) {
  return `
    <div class="col-12 col-md-6 col-lg-4 cs-card-col" data-industry="${study.categorySlug}">
      <button type="button" class="cs-card" aria-label="View case study for ${study.company}" id="outcome-${study.id}">
        <div class="cs-card__img-wrap">
          ${study.img
            ? `<img src="${study.img}" alt="${study.company}" class="cs-card__img" />`
            : `<div class="cs-card__img-placeholder"></div>`
          }
          <div class="cs-card__badges">
            <span class="cs-card__badge cs-card__badge--industry">${study.category}</span>
          </div>
        </div>
        <div class="cs-card__body">
          <h3 class="cs-card__title">
            ${study.title}
          </h3>
          <p class="cs-card__desc">${study.description}</p>
          <div class="cs-card__result">
            <span class="cs-card__result-label">KEY RESULT</span>
            <p class="cs-card__result-value">${study.keyResult}</p>
          </div>
          <div class="cs-card__footer">
            <span class="cs-card__company">${study.company}</span>
            <span class="cs-card__doc-btn">
              <span class="cs-card__outcome">${study.outcome}</span>
              <span class="cs-card__doc">
                <i data-lucide="file-text" class="cs-card__doc-icon"></i>
                PDF ${study.docYear}
                <i data-lucide="arrow-up-right" class="cs-card__doc-arrow"></i>
              </span>
            </span>
          </div>
        </div>
      </button>
    </div>
  `;
}

function renderCards(studies) {
  $('#cs-cards-container').html(
    studies.map(buildCardHtml).join('')
  );
  lucide.createIcons();
}

function renderFilters() {
  var $tabs = $('.cs-filters__tabs');
  $tabs.empty();

  $tabs.append(
    $('<button>', {
      class: 'cs-filters__tab cs-filters__tab--active',
      'data-filter': 'all',
      role: 'tab',
      'aria-selected': 'true',
      text: 'All',
    })
  );

  getCategories().forEach(function (cat) {
    $tabs.append(
      $('<button>', {
        class: 'cs-filters__tab',
        'data-filter': cat.slug,
        role: 'tab',
        'aria-selected': 'false',
        text: cat.label,
      })
    );
  });

  $tabs.on('click', '.cs-filters__tab', function () {
    $tabs.find('.cs-filters__tab')
      .removeClass('cs-filters__tab--active')
      .attr('aria-selected', 'false');

    $(this).addClass('cs-filters__tab--active').attr('aria-selected', 'true');

    renderCards(getStudies($(this).data('filter')));
  });
}

// ── PDF Modal ─────────────────────────────────────────────────────────────────

const studyById = Object.fromEntries(caseStudies.map(function (s) { return [s.id, s]; }));

var activeStudy = null;

function openPdfModal(study) {
  var $modal = $('#cs-pdf-modal');
  activeStudy = study;

  $('#cs-pdf-modal-meta').text(study.category);
  $('#cs-pdf-modal-title').text(study.title);
  $('#cs-pdf-modal-result-value').text(study.keyResult);
  $('#cs-pdf-modal-result-company').text(study.company);
  $('.cs-pdf-modal__banner-img').attr('src', study.img);

  $('#cs-pdf-email').val('');
  $('#cs-pdf-email-error-msg').text('');
  $modal.removeAttr('hidden');
  document.body.style.overflow = 'hidden';
  $('#cs-pdf-modal-close').trigger('focus');
}

function closePdfModal() {
  $('#cs-pdf-modal').attr('hidden', '');
  document.body.style.overflow = '';
  activeStudy = null;
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function downloadCaseStudyPdf(study) {
  var $link = $('<a>', {
    href: study.pdfUrl,
    download: study.title + '.pdf',
  }).appendTo('body');
  $link[0].click();
  $link.remove();
}

function handlePdfDownloadClick() {
  if (!activeStudy) return;

  var email = $('#cs-pdf-email').val().trim();

  if (!email || !isValidEmail(email)) {
    $('#cs-pdf-email-error-msg').text('Enter a valid email address (e.g. name@company.com).');
    return;
  }

  $('#cs-pdf-email-error-msg').text('');

  var payload = {
    payloadType: 'SWIREPAY_CASE_STUDY_PDF_DOWNLOAD',
    email: email,
    caseStudyTitle: activeStudy.title,
  };

  fetch(trackCaseStudyDownloadUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).catch(function () {});

  downloadCaseStudyPdf(activeStudy);
  closePdfModal();
}

// ── Init ──────────────────────────────────────────────────────────────────────

$(document).ready(function () {
  renderFilters();
  renderCards(getStudies('all'));

  // Card click — delegate so it works after re-renders
  $('#cs-cards-container').on('click', '.cs-card', function () {
    var id = $(this).attr('id').replace('outcome-', '');
    var study = studyById[id];
    if (study) openPdfModal(study);
  });

  // Download PDF — validate email, submit, then download and close
  $('#cs-pdf-modal-download').on('click', handlePdfDownloadClick);

  // Close via button or backdrop
  $(document).on('click', '#cs-pdf-modal-close, .cs-pdf-modal__backdrop', closePdfModal);

  // Close on Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && !$('#cs-pdf-modal').attr('hidden')) {
      closePdfModal();
    }
  });
});
